import { makeStyles } from '@material-ui/core';
import React from 'react';
import { Footer, Navbar } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.common.dark,
    color: theme.palette.common.white,
    height: '100%'
  },
}));

function PublicLayout(props) {
  const classes = useStyles(props);
  const { children, withFooter = true } = props;
  return (
    <div className={classes.root}>
      <Navbar />
      {children}
      {withFooter && <Footer />}
    </div>
  );
}

export default PublicLayout;
